import React from 'react';
import moment from 'moment';

import style from './style.module.css';
import { initialsFromName } from './helpers';
import { STAR_PATH, STAR_COUNT } from './constants';

const StarRating = ({ ratingValue }) => {
  const filledCount = Math.round(ratingValue || 0);

  return (
    <div className={style.stars}>
      {Array.from({ length: STAR_COUNT }, (_, index) => (
        <svg key={index} width="26" height="26" viewBox="0 0 20 20">
          <path d={STAR_PATH} fill={index < filledCount ? '#fcb51f' : '#dbdbdb'} />
        </svg>
      ))}
    </div>
  );
};

const ReviewSummaryCard = ({ review, companyName, logoUrl, language, reviewedLabel, reviewTypeLabel, responseFromLabel, ownerLabel }) => {
  if (!review) {
    return null;
  }

  const { reviewerName, date, ratingValue, reviewText, sourceTitle, locationTitle, ownerReply } = review;
  const replyAge =
    ownerReply && ownerReply.date
      ? ` · ${moment(ownerReply.date)
          .locale(language === 'ar' ? 'ar' : 'en')
          .fromNow()}`
      : '';

  return (
    <div className={style.card}>
      <div className={style.reviewer}>
        <div className={style.avatar}>{initialsFromName(reviewerName)}</div>
        <div className={style.reviewerInfo}>
          <div className={style.reviewerName}>
            <bdi>{reviewerName}</bdi>
          </div>
          <div className={style.meta}>
            {reviewedLabel} <bdi>{date}</bdi> · <bdi>{sourceTitle}</bdi> {reviewTypeLabel} · <bdi>{locationTitle}</bdi>
          </div>
        </div>
      </div>

      <StarRating ratingValue={ratingValue} />

      {reviewText ? (
        <div className={style.quoteWrap}>
          <span className={style.quoteMark}>&ldquo;</span>
          <p className={style.quote}>{reviewText}</p>
        </div>
      ) : null}

      {ownerReply ? (
        <div className={style.reply}>
          <div className={style.replyIcon}>
            <img src={logoUrl} alt="" />
          </div>
          <div className={style.replyBody}>
            <div className={style.replyHeader}>
              <span className={style.replyFrom}>
                {responseFromLabel} <bdi>{companyName}</bdi>
              </span>
              <span className={style.replyMeta}>
                {ownerLabel}
                {replyAge}
              </span>
            </div>
            <p className={style.replyText}>{ownerReply.text}</p>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ReviewSummaryCard;
